<!-- <p-toast></p-toast> -->
<div>
    <div class="card dashboardTable">
        <p-table #subsidyToFarmerPFMSReportTable [value]="subsidyToFarmerPFMSReportModel" [rows]="10"
            [paginator]="true"
            [globalFilterFields]="['Srno','Lot_No','dateofExport','Sum_of_PFMS_Export', 'Sum_of_Pending_Records', 'TargetDays', 'PendingCompletedDays', 'NoOfTimesExported','Sum_of_Centre_Share_AllRec', 'Sum_of_Centre_Share_FailedRec','Sum_of_Centre_Share_PenRec','Sum_of_Centre_Share_SuccessfullRec','Sum_of_State_Share_AllRec', 'Sum_of_State_Share_FailedRec','Sum_of_State_Share_PenRec','Sum_of_State_Share_SuccessfullRec','Sum_of_Successfull_Records','Sum_of_Failed_Records', 'Sum_of_Bank_Transfer_Successfull_Records', 'block', 'district', 'No_of_AllRecords', 'remarks', 'status','Status_Ar', 'village', 'lotNoForSorting', 'FinYear', 'No_of_Successfull_Records', 'No_of_Bank_Transfer_Successfull_Records', 'Total_Sum',
            'TopUp_All' ]"
            responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
            [showCurrentPageReport]="true" sortField="lotNoForSorting" [sortOrder]="1" [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <!-- Left side -->
                    <div class="col-5">
                        <h5 class="m-0">{{'SUBISDY_TO_FARMER_PFMS_REPORTS_DBT' | translate}}</h5>
                    </div>
                    <!-- Middle section for buttons -->
                    <div class="col-3 flex  justify-content-center">
                        <p-splitButton [model]="menuItems" icon="pi pi-download"
                            label="{{'' | translate}}"></p-splitButton>
                        <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button> -->
                        <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button>
                        <!-- <p-menu #menu [popup]="true" [model]="menuItems"></p-menu> -->
                    </div>
                    <!-- Right side for search -->
                    <div class="col-4 flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="subsidyToFarmerPFMSReportTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th pSortableColumn="Srno">{{'S_NO'| translate}}
                        <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                        <p-sortIcon field="Srno"></p-sortIcon>
                    </th> -->
                    <th pSortableColumn="lotNoForSorting">{{'FILE_NO'| translate}}
                        <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                        <p-sortIcon field="lotNoForSorting"></p-sortIcon>
                    </th>
                    <th pSortableColumn="dateofExport">{{'DATE_OF_EXPORT'| translate}}
                        <p-columnFilter type="text" field="dateofExport" display="menu"></p-columnFilter>
                        <p-sortIcon field="dateofExport"></p-sortIcon>
                    </th>
                    
                    <th pSortableColumn="Total_Sum">{{'TOTAL_SUM'| translate}}
                        <p-columnFilter type="text" field="Total_Sum" display="menu"></p-columnFilter>
                        <p-sortIcon field="Total_Sum"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_PFMS_Export">{{'SUM_OF_PFMS_EXPORT'| translate}}
                        <p-columnFilter type="text" field="Sum_of_PFMS_Export" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_PFMS_Export"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TargetDays">{{'TARGET_DAYS' | translate}}
                        <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="TargetDays"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                        <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="NoOfTimesExported">{{'NO_OF_TIMES_EXPORTED' | translate}}
                        <p-columnFilter type="text" field="NoOfTimesExported" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfTimesExported"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Sum_of_Centre_Share_AllRec">{{'SUM_OF_CENTRE_SHARE_(ALL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share_AllRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share_AllRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_State_Share_AllRec">{{'SUM_OF_STATE_SHARE_(ALL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share_AllRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share_AllRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TopUp_All">{{'SUM_OF_TOP_UP_(ALL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="TopUp_All" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="TopUp_All"></p-sortIcon>
                    </th>


                    <th pSortableColumn="Sum_of_Centre_Share_SuccessfullRec">{{'SUM_OF_CENTRE_SHARE_(SUCCESSFUL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share_SuccessfullRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share_SuccessfullRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_State_Share_SuccessfullRec">{{'SUM_OF_STATE_SHARE_(SUCCESSFUL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share_SuccessfullRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share_SuccessfullRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TopUp_Success">{{'SUM_OF_TOP_UP_(SUCCESSFUL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="TopUp_Success" display="menu"></p-columnFilter>
                        <p-sortIcon field="TopUp_Success"></p-sortIcon>
                    </th>


                    <th *ngIf="!isCAOLogin" pSortableColumn="Sum_of_Centre_Share_PenRec">{{'SUM_OF_CENTRE_SHARE_(PENDING_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share_PenRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share_PenRec"></p-sortIcon>
                    </th>                  
                    <th *ngIf="!isCAOLogin" pSortableColumn="Sum_of_State_Share_PenRec">{{'SUM_OF_STATE_SHARE_(PENDING_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share_PenRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share_PenRec"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="TopUp_Pend">{{'SUM_OF_TOP_UP_(PENDING_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="TopUp_Pend" display="menu"></p-columnFilter>
                        <p-sortIcon field="TopUp_Pend"></p-sortIcon>
                    </th>


                    <th pSortableColumn="Sum_of_Centre_Share_FailedRec">{{'SUM_OF_CENTRE_SHARE_(FAILED_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share_FailedRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share_FailedRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_State_Share_FailedRec">{{'SUM_OF_STATE_SHARE_(FAILED_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share_FailedRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share_FailedRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TopUp_Failed">{{'SUM_OF_TOP_UP_(FAILED_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="TopUp_Failed" display="menu"></p-columnFilter>
                        <p-sortIcon field="TopUp_Failed"></p-sortIcon>
                    </th>
                    

                    <th pSortableColumn="No_of_AllRecords">{{'NO_OF_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_AllRecords" display="menu"></p-columnFilter>
                        <p-sortIcon field="No_of_AllRecords"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_Successfull_Records">{{'NO_OF_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Successfull_Records"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="NoOfPendingRecords">{{'NO_OF_PENDING_RECORDS'| translate}}
                        <p-columnFilter type="text" field="NoOfPendingRecords" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="NoOfPendingRecords"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NoOfFailedRecords">{{'NO_OF_FAILED_RECORDS'| translate}}
                        <p-columnFilter type="text" field="NoOfFailedRecords" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="NoOfFailedRecords"></p-sortIcon>
                    </th>


                    <th pSortableColumn="Sum_of_Successfull_Records">{{'SUM_OF_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Successfull_Records"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="Sum_of_Pending_Records">{{'SUM_OF_PENDING_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Pending_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Pending_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Failed_Records">{{'SUM_OF_FAILED_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Failed_Records" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Failed_Records"></p-sortIcon>
                    </th>

                    <th pSortableColumn="No_of_Bank_Transfer_Successfull_Records">{{'NO_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Bank_Transfer_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Bank_Transfer_Successfull_Records">{{'SUM_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Bank_Transfer_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                        <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                        <p-sortIcon field="FinYear"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                    <!-- <td>{{product.Srno}}</td> -->
                    <td><button (click)="pmfsExport(product.Lot_No, '')" pButton pRipple type="button"
                            label="{{product.Lot_No}}" class="p-button-text"></button></td>
                    <td>{{product.dateofExport}}</td>
                    <td>{{product.Total_Sum}}</td>
                    <td>{{product.Sum_of_PFMS_Export}}</td>
                    <td>{{product.TargetDays}}</td>
                    <td>{{product.PendingCompletedDays}}</td>
                    <td *ngIf="!isCAOLogin">{{product.NoOfTimesExported}}</td>

                    <td>{{product.Sum_of_Centre_Share_AllRec}}</td>
                    <td>{{product.Sum_of_State_Share_AllRec}}</td>
                    <td>{{product?.TopUp_All}}</td>

                    <td>{{product.Sum_of_Centre_Share_SuccessfullRec}}</td>
                    <td>{{product.Sum_of_State_Share_SuccessfullRec}}</td>
                    <td>{{product.TopUp_Success}}</td>

                    <td *ngIf="!isCAOLogin">{{product.Sum_of_Centre_Share_PenRec}}</td>
                    <td *ngIf="!isCAOLogin">{{product.Sum_of_State_Share_PenRec}}</td>
                    <td *ngIf="!isCAOLogin">{{product.TopUp_Pend}}</td>

                    <td>{{product.Sum_of_Centre_Share_FailedRec}}</td>
                    <td>{{product.Sum_of_State_Share_FailedRec}}</td>
                    <td>{{product.TopUp_Failed}}</td>

                    <td>{{product.No_of_AllRecords}}</td>
                    <td>{{product?.No_of_Successfull_Records}}</td>
                    <td *ngIf="!isCAOLogin">{{product?.NoOfPendingRecords}}</td>
                    <td>{{product?.NoOfFailedRecords}}</td>
            
                    <td><button (click)="pmfsExport(product.Lot_No, 'S')" pButton pRipple type="button"
                        label="{{product?.Sum_of_Successfull_Records}}" class="p-button-text"></button></td>
                    <td *ngIf="!isCAOLogin"><button (click)="pmfsExport(product.Lot_No, 'P')" pButton pRipple type="button"
                        label="{{product?.Sum_of_Pending_Records}}" class="p-button-text"></button></td>
                    <td><button (click)="pmfsExport(product.Lot_No, 'F')" pButton pRipple type="button"
                        label="{{product?.Sum_of_Failed_Records}}" class="p-button-text"></button></td>
                    
                    <td>{{product?.No_of_Bank_Transfer_Successfull_Records}}</td>
                    <td>{{product.Sum_of_Bank_Transfer_Successfull_Records}}</td>
                    <td>{{product.FinYear}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex  justify-content-between flex-column ">
                    <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{subsidyToFarmerPFMSReportModel ?
                        subsidyToFarmerPFMSReportModel.length : 0 }} {{'RECORDS_ADDED'| translate}}
                    </p>
                    <div class="flex  justify-content-between flex-column "> 
                        <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_THREE_OR_MORE_DAYS' | translate}}</div>
                        <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_OR_TWO_DAYS' | translate}}</div>
                        <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APPROVED_ON_TIME' | translate}}</div>
                    </div>
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<p-dialog [(visible)]="addDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
    <div class="mi-survey-container">
        <div class="card dashboardTable">
            <p-table #miSurvey [value]="miSurveyData" [rows]="10"
                [paginator]="true" [globalFilterFields]="[
                'Farmer_Name_In_English',
                'Aadhar_Number', 
                'Scheme_Specific_Id',
                'Center_Share_Payment_Amount', 
                'State_Share_Payment_Amount', 
                'TopUp',
                'SubsidyToFarmer_Amount',
                'totalAmountSum'
                ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                [showCurrentPageReport]="true" [loading]="loading1"
                (onFilter)="onMiSurveyFilter($event)" (onPage)="onMiSurveyPage($event)">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MI_SUBSIDY_TO_FARMER_LOT_DBT'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH' | translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th>
                        <th>{{'FARMER_NAME' | translate}}</th>
                        <th>{{'AADHAR_NUMBER' | translate}}</th>
                        <th>{{'SCHEME_SPECIFIC_ID' | translate}}</th>
                        <th >{{'CENTER_SHARE_PAYMENT_AMOUNT' | translate}}</th>
                        <th>{{'STATE_SHARE_PAYMENT_AMOUNT' | translate}}</th>
                        <th>{{'TOP_UP' | translate}}</th>
                        <th>{{'AMOUNT' | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="selectFarmerApplication(product)"></button>
                        </td>
                        <td>{{product?.Farmer_Name_In_English}}</td>
                        <td>{{product?.Aadhar_Number}}</td>
                        <td>{{product?.Scheme_Specific_Id}}</td>
                        <td>{{product?.Center_Share_Payment_Amount}}</td>
                        <td>{{product?.State_Share_Payment_Amount}}</td>
                        <td>{{product?.TopUp}}</td>
                        <td>{{product?.totalAmountSum}}</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="footer">
                    <tr *ngIf="miSurveyData?.length > 0">
                        <td colspan="4"><b>Total (Current Page)</b></td>
                        <td><b>{{miPageTotals?.centerShare | number:'1.2-2'}}</b></td>
                        <td><b>{{miPageTotals?.stateShare | number:'1.2-2'}}</b></td>
                        <td><b>{{miPageTotals?.topUp | number:'1.2-2'}}</b></td>
                        <td><b>{{miPageTotals?.subsidyToFarmer | number:'1.2-2'}}</b></td>
                    </tr>
                    <tr *ngIf="miSurveyData?.length > 0">
                        <td colspan="4"><b>Grand Total (All Rows)</b></td>
                        <td><b>{{miGrandTotals?.centerShare | number:'1.2-2'}}</b></td>
                        <td><b>{{miGrandTotals?.stateShare | number:'1.2-2'}}</b></td>
                        <td><b>{{miGrandTotals?.topUp | number:'1.2-2'}}</b></td>
                        <td><b>{{miGrandTotals?.subsidyToFarmer | number:'1.2-2'}}</b></td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }} {{'MI_SUBSIDY_TO_FARMER_LOT_APPLICATIONS_ADDED'| translate}}
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div *ngIf="miSurveyData?.length > 0 && !isDuplicateFound" class="card">
            <div class="row">
                <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_FILTERED_FOR_MI_SUBSIDY_TO_FARMER_LOT' | translate}}: {{
                        miSurveyData?.length }}</b>
                </h5>
                <div class="flex justify-content-end">
                    <p-splitButton [model]="appVerificationItems" icon="pi pi-download"
                        label="{{'EXPORT' | translate}}"></p-splitButton>
                </div>
            </div>
        </div>
    </div>
</p-dialog>